function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 73.03,
  y1: -57.69,
  x2: 73.03,
  y2: 268.76,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0b73b6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#0d72b4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#0e71b3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#3172af"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#6f74a8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#8775a5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e96d28"
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Asset 2");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M143.46,222a73.55,73.55,0,0,0-7.34-17.44,73.84,73.84,0,0,0-26.2-26.2c-1.93-1.13-3.92-2.16-6-3.11h0c-8.81-4.79-12.79-11.13-12.79-18s4-13.21,12.79-18h0c2-1,4-2,6-3.14a74.7,74.7,0,0,0,14.78-11.48,72.17,72.17,0,0,0,11.42-14.82,74.71,74.71,0,0,0,7.34-17.43,73.26,73.26,0,0,0,0-38.76,72.94,72.94,0,0,0-51-51,73.26,73.26,0,0,0-38.76,0A74.35,74.35,0,0,0,36.3,10,72.5,72.5,0,0,0,21.47,21.37,74.36,74.36,0,0,0,10,36.15,72.92,72.92,0,0,0,2.61,92.34,73.88,73.88,0,0,0,36.3,136.07c1.88,1.11,3.82,2.12,5.8,3.06h0c8.95,4.81,12.79,11.13,12.79,18.09s-3.84,13.3-12.79,18.11h0q-3,1.39-5.81,3a72.41,72.41,0,0,0-14.82,11.43A74.3,74.3,0,0,0,10,204.56,72.32,72.32,0,0,0,0,241.4a71.27,71.27,0,0,0,2.61,19.35A73.27,73.27,0,0,0,21.47,293a73,73,0,0,0,32.26,18.86,73.26,73.26,0,0,0,38.76,0,72.53,72.53,0,0,0,17.43-7.38A74.35,74.35,0,0,0,124.69,293a71.87,71.87,0,0,0,11.43-14.82,74.61,74.61,0,0,0,7.34-17.44,73.22,73.22,0,0,0,0-38.75ZM27.68,92A47.09,47.09,0,0,1,23.8,73a47.86,47.86,0,0,1,3.88-19.15A49.36,49.36,0,0,1,38.25,38.2,50.57,50.57,0,0,1,53.89,27.69a49.18,49.18,0,0,1,38.34,0,49,49,0,0,1,26.16,26.15A47.86,47.86,0,0,1,122.27,73a47.09,47.09,0,0,1-3.88,19,50.62,50.62,0,0,1-10.52,15.58,49.14,49.14,0,0,1-15.64,10.57,49.3,49.3,0,0,1-38.34,0A49.86,49.86,0,0,1,27.68,92Zm89.66,168a49.41,49.41,0,0,1-10.28,15.23,48.21,48.21,0,0,1-15.27,10.32,48.18,48.18,0,0,1-37.46,0A48.6,48.6,0,0,1,28.73,260a45.94,45.94,0,0,1-3.79-18.6,46.73,46.73,0,0,1,3.79-18.7,48.21,48.21,0,0,1,10.32-15.27,49.29,49.29,0,0,1,15.28-10.28,48.18,48.18,0,0,1,37.46,0,48,48,0,0,1,25.55,25.55,46.73,46.73,0,0,1,3.79,18.7A45.94,45.94,0,0,1,117.34,260Z"
})));

const SvgSensorflow8 = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 146.07 314.48",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSensorflow8, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sensorflow-8.a2b7661f.svg";
export { ForwardRef as ReactComponent };